import { Skeleton, Stack, Typography, useTheme } from '@mui/material'

import { useOrgUser, useUser } from '@cibo/profile'
import { intuitiveFromNow } from '@cibo/ui'

import { statusIcon } from './StatusUIMaps'
import { AgreementHistoryNote } from './types'

export const AgreementNoteView = ({ note }: { note: AgreementHistoryNote }) => {
  const { data: orgUser, isFetching: orgUserFetching } = useOrgUser(note.userId)
  const { data: currentUser } = useUser()
  const { palette } = useTheme()

  const fromLoggedInUser = currentUser?.matchUserId(note.userId)

  return (
    <Stack
      alignItems={fromLoggedInUser ? 'flex-end' : 'flex-start'}
      spacing={0.5}
      sx={{
        background: palette.background.paper,
        padding: 0.5,
        borderStyle: 'solid',
        borderColor: palette.secondary.main,
        borderWidth: 0,
        borderRightWidth: fromLoggedInUser ? 5 : 0,
        borderLeftWidth: fromLoggedInUser ? 0 : 5,
        paddingRight: fromLoggedInUser ? 2 : 0,
        paddingLeft: fromLoggedInUser ? 0 : 2,
      }}
    >
      <Typography variant="caption" alignItems="center" display="flex">
        {note.status && statusIcon[note.status]}
        {orgUserFetching ? <Skeleton /> : !!orgUser && orgUser.displayNameFull}
        {' - '}
        {intuitiveFromNow(note.createdDate)}
      </Typography>
      <Typography>{note.note || (note.action === 'create' ? 'create' : note.status)}</Typography>
    </Stack>
  )
}
